import AuthService from 'services/AuthService'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequirePhysicianOrAncillaryMiddleware from 'middlewares/RequirePhysicianOrAncillaryMiddleware'
import RequirePhysicianOrAncillaryOrDemoMiddleware from 'middlewares/RequirePhysicianOrAncillaryOrDemoMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import CheckPracticeMemberTypeForNonPhysicianMiddleware from 'middlewares/CheckPracticeMemberTypeForNonPhysicianMiddleware'
import RequireIntroCompletedMiddleware from 'middlewares/RequireIntroCompletedMiddleware'
import RequireFindProviderSearchMiddleware from 'middlewares/RequireFindProviderSearchMiddleware'
import RequireNotMobileMiddleware from 'middlewares/RequireNotMobileMiddleware'

export default [
    {
        path: '/',
        name: 'index',
        redirect: () => (AuthService.isLoggedIn() ? { name: 'index.home' } : { name: 'auth.login' }),
    },
    {
        path: '/home',
        name: 'index.home',
        view: 'index/Home',
        middlewares: [
            RequireIntroCompletedMiddleware,
            RequireSignupFinishedMiddleware,
            RequirePhysicianOrAncillaryOrDemoMiddleware,
            CheckPracticeMemberTypeForNonPhysicianMiddleware,
            RequireUserMiddleware,
            RequireFindProviderSearchMiddleware,
        ],
    },
    {
        path: '/members-nearby',
        name: 'index.members.nearby',
        default: { query: { limit: 6 } },
        view: 'index/MembersNearby',
        middlewares: [
            RequireSignupFinishedMiddleware,
            RequirePhysicianOrAncillaryMiddleware,
            CheckPracticeMemberTypeForNonPhysicianMiddleware,
            RequireUserMiddleware,
        ],
    },
    {
        path: '/intro',
        name: 'index.intro',
        view: 'index/Intro',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware, RequireNotMobileMiddleware],
    },
]
